import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { IntegrationSettingsFragments } from '../../graphql/integrationSettings.graphql';
import { IntegrationSettings } from '../../types/integration_settings';
import { useDispatch } from 'react-redux';
import { integrationSettingsSlice } from '../../providers/IntegrationProvider';

const integrationSettingsSubscription = gql`
  subscription integrationSettingsNotification($companyId: String!) {
    integrationSettingsNotification(companyId: $companyId) {
      companyId
      entities {
        ...IntegrationSettings
      }
      topic
      date
    }
  }
  ${IntegrationSettingsFragments.integrationSettings}
`;

export class IntegrationSettingsNotificationResponse extends forNotification<IntegrationSettings>(
  'integrationSettingsNotification',
) {}

export default function IntegrationSettingsNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useDispatch();

  if (!currentCompany) return null;

  const { data: integrationSettingsNotification } = useSubscription<IntegrationSettingsNotificationResponse>(
    integrationSettingsSubscription,
    {
      variables: { companyId: currentCompany.id },
    },
  );

  const handleIntegrationSettingsNotification = (notification?: IntegrationSettingsNotificationResponse) => {
    if (!notification?.integrationSettingsNotification) return;
    const integrationSettingsNotification = notification.integrationSettingsNotification;

    switch (integrationSettingsNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(integrationSettingsSlice.actions.add(integrationSettingsNotification.entities));
        break;
      case 'DELETE':
        dispatch(integrationSettingsSlice.actions.delete(integrationSettingsNotification.entities));
    }
  };

  useEffect(() => {
    handleIntegrationSettingsNotification(integrationSettingsNotification);
  }, [integrationSettingsNotification]);

  return <></>;
}
